import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { MediaProps } from '../../../types/composer';

type Props = { media: MediaProps };

/**
 * Media type block.
 */
const Media = (props: Props) => {
  const { media } = props;
  const autoplay = media.autoplay?.toString() === 'true';
  const controls = media.controls?.toString() === 'true';
  const loop = media.loop?.toString() === 'true';

  const [playing, setPlaying] = useState(false);

  const handleVideoClick = () => {
    !(controls || autoplay) && setPlaying((playing) => !playing);
  };

  useEffect(() => {
    if (autoplay) {
      setPlaying(true);
    }
  }, [autoplay]);

  return (
    <>
      {media.type === 'video' && (
        <Box aria-hidden="true">
          <Box className="relative pt-[56.25%]">
            <ReactPlayer
              data-testid="media-video"
              onClick={handleVideoClick}
              width="100%"
              height="100%"
              className="react-player absolute top-0 left-0"
              url={media.src}
              controls={controls}
              loop={loop}
              playing={autoplay || playing}
            />
          </Box>
        </Box>
      )}
      {media.type === 'image' && (
        <Box className="p-4">
          <img
            src={media.src}
            alt={media.altText ? media.altText : ''}
            className="w-full"
          />
        </Box>
      )}
      {media.type === 'svg' && (
        <Box>
          <img src={media.src} alt={media.altText ? media.altText : ''} />
        </Box>
      )}
    </>
  );
};

export default Media;
